import React from "react";

/* content for main Hero section: */
import HomeHeroIconsDesktopSvg from "./images/home-hero-icons-desktop.svg";
import HomeHeroIconsMobileSvg from "./images/home-hero-icons-mobile.svg";

export const heroTitle = "Icons and Photos For Everything";

export const heroSvgDesktop = HomeHeroIconsDesktopSvg;

export const heroSvgMobile = HomeHeroIconsMobileSvg;

/* content for Collections: */

// Collection Images:
import Whimsical from "./images/whimsical.png";
import Harvest from "./images/harvest-photos.png";
import FarmAnimalPhotos from "./images/FarmAnimalPhotos.png";
import MockupPhotos from "./images/MockupPhotos.png";

import IconSetBrowse from "./images/icon-set-browse.png";
import IconSetDogs from "./images/icon-set-dogs.svg";
import IconSetFuturisticTechnology from "./images/icon-set-futuristic-technology.svg";
import IconSetIconathonSvg from "./images/icon-set-iconathon.svg";
import IconSetAutumn from "./images/icon-set-autumn.png";

export const collectionsTitle =
    "Noun Project is building a global visual language that unites us.";

export const collections = [
    {
        title: "Iconathon",
        subtitle: "Redefining Women Collection",
        url: "/Iconathon1/collection/redefining-women/",
        imageSrcAndTitle: {
            imageSrc: IconSetIconathonSvg,
            title: "Iconathon"
        },
        type: "darkMode"
    },
    {
        title: "Harvest Photos",
        subtitle: null,
        url: "/search/photos/?photospage=1&q=harvest",
        imageSrcAndTitle: {
            imageSrc: Harvest,
            title: "Harvest"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Dogs",
        subtitle: null,
        url: "/an.derevyanko/collection/dogs/",
        imageSrcAndTitle: {
            imageSrc: IconSetDogs,
            title: "Dogs"
        },
        type: "primary"
    },
    {
        title: "Whimsical Photos",
        subtitle: null,
        url: "/browse/creator/zamurovic.brothers/photos/",
        imageSrcAndTitle: {
            imageSrc: Whimsical,
            title: "Whimsical Photos"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "Futuristic Technology",
        subtitle: null,
        url: "/vinzencestudio/collection/futuristic-technology/",
        imageSrcAndTitle: {
            imageSrc: IconSetFuturisticTechnology,
            title: "Futuristic Technology"
        },
        type: "primary"
    },
    {
        title: "Farm Animal Photos",
        subtitle: null,
        url: "/search/photos/?photospage=1&q=farm%20animals",
        imageSrcAndTitle: {
            imageSrc: FarmAnimalPhotos,
            title: "Farm Animal Photos"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "Autumn",
        subtitle: null,
        url: "/browse/collection-icon/autumn-icon-pack-97141/?p=1",
        imageSrcAndTitle: {
            imageSrc: IconSetAutumn,
            title: "Autumn"
        },
        type: "primary"
    },
    {
        title: "Mockup Photos",
        subtitle: null,
        url: "/search/photos/?photospage=1&q=mockups",
        imageSrcAndTitle: {
            imageSrc: MockupPhotos,
            title: "Mockup Photos"
        },
        isPhoto: true,
        type: "primary"
    },

    {
        title: "Browse New Icons",
        subtitle: null,
        url: "/browse/",
        imageSrcAndTitle: {
            imageSrc: IconSetBrowse,
            title: "Browse New Icons"
        },
        type: "primary"
    }
];

/* content for Recent Posts: */
import RecentPostsImg1 from "./images/the-list-2022.png";
import RecentPostsImg2 from "./images/recent-posts-animate.png";
import RecentPostsImg3 from "./images/recent-posts-hytken.png";

export const recentPostsTitle = "Recent Posts";

export const recentPosts = [
    {
        title: "Top Illustrators & Designers of 2022",
        category: "Spotlight",
        imgSrc: RecentPostsImg1,
        url: "https://thelist.thenounproject.com/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "How to Animate Icons in Figma",
        category: "Tutorial",
        imgSrc: RecentPostsImg2,
        url:
            "https://blog.thenounproject.com/microinteractions-in-ui-design-how-to-animate-icons-in-figma/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Representing Disability with Jake Hytken of Snap, Inc.",
        category: "Interview",
        imgSrc: RecentPostsImg3,
        url:
            "https://blog.thenounproject.com/disability-representation-with-jake-hytken-of-snap-inc/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

/* Content for Promo section: */
import { PRICING, appsAndPluginsPath, API_LANDING_PAGE } from "data/links";
import Payouts from "core/ReusableIcons/Payouts";
import Computer from "core/ReusableIcons/Computer";
import Api from "core/ReusableIcons/Api";

import AppAppleSvg from "./images/AppAppleSvg";
import AppAdobeSvg from "./images/AppAdobeSvg";
import AppMicrosoftSvg from "./images/AppMicrosoftSvg";
import AppGsuiteSvg from "./images/AppGsuiteSvg";

export const promo = [
    {
        url: PRICING,
        iconName: <Payouts size="xl" title="Pricing &amp; Licenses" />,
        title: "Pricing & Licenses",
        description:
            "All images available as free downloads. Purchase a royalty-free license to support artists and get more options.",
        learnMoreContent: "Learn More"
    },
    {
        url: appsAndPluginsPath,
        iconName: <Computer size="xl" title="Apps &amp; Plugins" />,
        title: "Apps & Plugins",
        description:
            "Drag and drop icons into the software you use. Access vector, png, & pdf from Mac, PowerPoint, Adobe, Google, more.",
        learnMoreContent: [
            {
                icon: <AppAppleSvg title="Apple" />
            },
            {
                icon: <AppAdobeSvg title="Adobe" />
            },
            {
                icon: <AppMicrosoftSvg title="Microsoft" />
            },
            {
                icon: <AppGsuiteSvg title="GSuite" />
            }
        ]
    },
    {
        url: API_LANDING_PAGE,
        iconName: <Api size="xl" title="API" />,
        title: "API",
        description:
            "Access the entire icon collection via our REST API. Reliably supports growth stage to enterprise clients. ",
        learnMoreContent: "Learn More"
    }
];
